import { render, staticRenderFns } from "./BodyStageCongratulations.vue?vue&type=template&id=30135dd1&scoped=true&"
import script from "./BodyStageCongratulations.vue?vue&type=script&lang=js&"
export * from "./BodyStageCongratulations.vue?vue&type=script&lang=js&"
import style0 from "./BodyStageCongratulations.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BodyStageCongratulations.vue?vue&type=style&index=1&id=30135dd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30135dd1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
